module.exports = __webpack_public_path__ + "img/icon_controltemp.e7486d65.svg";